import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { TableBody, TableRow, Table } from "@material-ui/core";
import CatalogoAgenteTipo3 from "../../catalogos/catalogoAgenteTipo3";
import { Dimmer } from "../spinner";

export const GestionarTributos = (props) => {
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [catalogo, setCatalogo] = useState(false);
  const [activate, setActivate] = useState(false);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const [fechas, setFechas] = useState(0.0);
  const [tipotributo, setTipotributo] = useState([]);
  const [tipoImpuestos, setTipoImpuestos] = useState([]);

  const [values, setValues] = useState();
  const [usuario, setUsuario] = useState();
  const [operacion, setOperacion] = useState(0);
  const [activo, setActivo] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [activo1, setActivo1] = useState(false);
  const [checkk, setCheckk] = useState(false);
  const [tipo, setTipo] = useState();
  const [tipovalor, setTipovalor] = useState();
  const txtMina = useRef();
  const txtProduccion = useRef();
  const txtTimbres = useRef();
  const txtIdagente = useRef();
  const txt1x500 = useRef();
  const txtDireccion = useRef();
  const txtNombre = useRef();
  const txtRif = useRef();
  const cmbTipoImpuesto = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const token = JSON.parse(localStorage.getItem("jwtToken"));
  let op = require("../../../public/modulos/datos");

  const onChange = (event) => {
    if (
      event.target.name === "direccion" ||
      event.target.name === "rif" ||
      event.target.name === "nombre" ||
      event.target.name === "concepto"
    ) {
      event.target.value = event.target.value.toUpperCase();
      setValues({ ...values, [event.target.name]: event.target.value });
    } else {
      setValues({ ...values, [event.target.name]: event.target.value });
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    /* if (txtTimbres.current.checked === false && txtMina.current.checked === false && txtProduccion.current.checked === false && txt1x500.current.checked === false) {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe seleccionar el Tipo de Contribuyente', icono: 'informacion' });
            sigue = false;
            txtTimbres.current.focus()

        } */
    if (cmbTipoImpuesto.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "debe seleccionar el tributo",
        icono: "informacion",
      });
      sigue = false;
      cmbTipoImpuesto.current.focus();
    } else if (txtNombre.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Nombre no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombre.current.value = "";
      txtNombre.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Campo Rif no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtRif.current.value = "";
      txtRif.current.focus();
    } else if (txtDireccion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Dirección",
        icono: "informacion",
      });
      sigue = false;
      txtDireccion.current.value = "";
      txtDireccion.current.focus();
    } else if (sigue) {
      let msg = "";
      if (operacion === 4) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 5) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const ActualizarTributos = () => {
    let endpoint = `${op.conexion}/api/usuarioweb/actualizartributos/${operacion}`;
    let body;
    setActivate(true);

    body = {
      idusuariow: parseInt(props.idusuario),
      tributo: tipotributo.trim(),
      idtributo: parseInt(txtIdagente.current.value),
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 4) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 5) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    ActualizarTributos();
  };

  const blanquear = () => {
    txtNombre.current.value = "";
    txtDireccion.current.value = "";
    txtRif.current.value = "";
    txtIdagente.current.value = "";
    setActivo(true);
    setActivo1(false);
    setActivo2(true);
    setCheckk(false);
  };

  const cancelar = (e) => {
    e.preventDefault();
    props.onHideCancelar();
    blanquear();
  };

  const handleCatalogo = () => {
    if (!catalogo) {
      setCatalogo(true);
    } else {
      setCatalogo(false);
    }
  };

  const onHideAceptaCatAge = (id, nom, rif, direccion, status) => {
    setCatalogo(false);
    if (tipo === "expendedor") {
      if (status === "51") {
        txtIdagente.current.value = id;
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtIdagente.current.value = "";
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "mina") {
      if (status === "51") {
        txtIdagente.current.value = id;
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtIdagente.current.value = "";
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "produccion") {
      if (status === "51") {
        txtIdagente.current.value = id;
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtIdagente.current.value = "";
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txtProduccion.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    } else if (tipo === "impuesto1x500") {
      if (status === "51") {
        txtIdagente.current.value = id;
        txtNombre.current.value = nom;
        txtRif.current.value = rif;
        txtDireccion.current.value = direccion;
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "AGENTE INACTIVO, CONTACTE CON EL ADMINISTRADOR",
          icono: "error",
        });
        txtIdagente.current.value = "";
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        txtTimbres.current.checked = checkk;
        txtMina.current.checked = checkk;
        txt1x500.current.checked = checkk;
        blanquear();
      }
    }
  };

  const cerrarModal = () => {
    props.onHideCancelar();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const seleccionarRegistros = () => {
    setActivate(true);
    let campos = "*";
    let id = 1;
    let nomtab = "tipoimpuesto";
    let nomid = "pagosweb";
    let endpoint = `${op.conexion}/api/consultaweb/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          let element = [];

          console.log(response.data);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].tabla.trim() !== "guia") {
              element.push(response.data[i]);
            }
          }
          setTipoImpuestos(element);
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto:
            error.response === undefined
              ? "Error de Conexion"
              : error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onchangeSelect = (e) => {
    let i = e.target.value;

    if (i === "") {
      setTipotributo("");
      setTipo("");
      setTipovalor(false);
      txtNombre.current.value = "";
      txtRif.current.value = "";
      txtDireccion.current.value = "";
      setActivo(true);
    } else {
      if (tipoImpuestos[i].tabla.trim() === "expendedores") {
        setTipo("expendedor");
        setTipovalor(true);
        setTipotributo("timbres");
        setActivo(false);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
      } else if (tipoImpuestos[i].tabla.trim() === "mina") {
        setTipo("mina");
        setTipotributo("mina");
        setTipovalor(true);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        setActivo(false);
      } else if (tipoImpuestos[i].tabla.trim() === "produccion") {
        setTipo("produccion");
        setTipotributo("produccion");
        setTipovalor(true);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        setActivo(false);
      } else if (tipoImpuestos[i].tabla.trim() === "1x500") {
        setTipotributo("1x500");
        setTipo("impuesto1x500");
        setTipovalor(true);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        setActivo(false);
      } else {
        setTipotributo("");
        setTipo("");
        setTipovalor(false);
        txtNombre.current.value = "";
        txtRif.current.value = "";
        txtDireccion.current.value = "";
        setActivo(true);
      }
    }
  };

  /*  const onCheck = () => {

        if (txtTimbres.current.checked) {
            setTipo("idtipoagente");
            setTipovalor("4");
            setTipotributo("timbres");
            setActivo(false);
            txtNombre.current.value = "";
            txtRif.current.value = "";
            txtDireccion.current.value = "";
        } else if (txtMina.current.checked) {
            setTipo("mina");
            setTipotributo("mina");
            setTipovalor(true);
            txtNombre.current.value = "";
            txtRif.current.value = "";
            txtDireccion.current.value = "";
            setActivo(false);
        } else if (txtProduccion.current.checked) {
            setTipo("produccion");
            setTipotributo("produccion");
            setTipovalor(true);
            txtNombre.current.value = "";
            txtRif.current.value = "";
            txtDireccion.current.value = "";
            setActivo(false);
        } else if (txt1x500.current.checked) {
            setTipotributo("1x500");
            setTipo("impuesto1x500");
            setTipovalor(true);
            txtNombre.current.value = "";
            txtRif.current.value = "";
            txtDireccion.current.value = "";
            setActivo(false);
        }

    } */

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0, 0, 0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        btnAcepta.current.focus();
        setOperacion(props.operaciontri);

        if (props.operaciontri === 4) {
          setUsuario(props.idusuario);
          setActivo1(false);
          blanquear();
        } else {
          blanquear();
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operaciontri === 4
              ? "Registrar Tributos"
              : "Eliminar Tributos"}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <CatalogoAgenteTipo3
          show={catalogo}
          tipo={tipo}
          valor={tipovalor}
          onHideCancelaCatAge={handleCatalogo}
          onHideAceptaCatAge={onHideAceptaCatAge}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className="titulos"
          style={{
            height: "auto",
            minHeight: "auto",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <div className="container">
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">Datos Generales</legend>

              <div className="col-md-12 py-2"></div>

              {/*  <fieldset className='row border-azul col-md-9 rounded mx-auto'>
                                <legend className="float-none m-0 w-auto">Tipo de Contribuyente</legend>
                                <div className='col-md-12 row m-0 py-1'>

                                    <div className='col-sm-2 ml-auto'>
                                        <div className="form-check">
                                            <input className="form-check-input" disabled={activo1} ref={txtTimbres} type="radio" name="exampleRadios" id="exampleRadios1" onChangeCapture={onCheck} />
                                            <label className="form-check-label" for="exampleRadios1">
                                                Timbres
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-sm-2 ml-auto'>
                                        <div className="form-check">
                                            <input className="form-check-input" disabled={activo1} ref={txtMina} type="radio" name="exampleRadios" id="exampleRadios2" onChangeCapture={onCheck} />
                                            <label className="form-check-label" for="exampleRadios2">
                                                Minas
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-sm-2 ml-auto'>
                                        <div className="form-check px-2">
                                            <input className="form-check-input" disabled={activo1} ref={txtProduccion} type="radio" name="exampleRadios" id="exampleRadios3" onChangeCapture={onCheck} />
                                            <label className="form-check-label" for="exampleRadios3">
                                                Producción
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-sm-2 ml-auto'>
                                        <div className="form-check">
                                            <input className="form-check-input" disabled={activo1} ref={txt1x500} type="radio" name="exampleRadios" id="exampleRadios4" onChangeCapture={onCheck} />
                                            <label className="form-check-label" for="exampleRadios4">
                                                1x500
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </fieldset>

                            <div className='col-md-12 py-1'></div> */}

              <div className="col-md-12 py-2 row m-0">
                <div className="input-group py-1 input-group-sm col-sm-6">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    Tributo:
                  </label>
                  <select
                    className="form-control form-control-sm"
                    id="inputtipo"
                    name="tipoimpuesto"
                    ref={cmbTipoImpuesto}
                    onChange={onchangeSelect}
                  >
                    <option value="">Seleccione</option>
                    {tipoImpuestos &&
                      tipoImpuestos.map((item, index) => (
                        <option key={index} value={index}>
                          {" "}
                          {item.descripcion.trim()}{" "}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="col-sm-4 col-12 py-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula o RIF:
                    </label>
                    <input
                      type="text"
                      disabled={activo2}
                      ref={txtRif}
                      name="rif"
                      className="form-control bg-light"
                      defaultValue={
                        props.tributos && props.tributos.rif !== null
                          ? props.tributos.rif
                          : ""
                      }
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={onChange}
                    />
                    <button
                      className="btn btn-info"
                      disabled={activo}
                      onClick={handleCatalogo}
                    >
                      <i className="fa fa-search"></i>
                    </button>
                  </div>
                </div>
                <div className="col-sm-12 col-12 py-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre del Contribuyente:
                    </label>
                    <input
                      type="text"
                      disabled={activo2}
                      ref={txtNombre}
                      name="nombre"
                      className="form-control bg-light"
                      defaultValue={
                        props.tributos && props.tributos.nombre !== null
                          ? props.tributos.nombre
                          : ""
                      }
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={onChange}
                    />
                    <input
                      type="hidden"
                      disabled={activo2}
                      ref={txtIdagente}
                      name="id"
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-12 py-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <textarea
                      disabled={activo2}
                      ref={txtDireccion}
                      autoComplete="off"
                      style={{ height: "50px" }}
                      name="direccion"
                      className="form-control bg-light"
                      defaultValue={
                        props.tributos && props.tributos.direccion !== null
                          ? props.tributos.direccion
                          : ""
                      }
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-md-12 py-1"></div>

            <div className="col-sm-12 py-1 d-flex justify-content-end  align-items-center">
              <button
                ref={btnAcepta}
                onClick={onChangeValidar}
                className="btn btn-sm rounded-pill btn-success col-md-2"
              >
                <i className="fas fa-check-circle"> Aceptar</i>
              </button>
              <button
                ref={btnCancela}
                onClick={cancelar}
                className="btn btn-danger btn-sm rounded-pill col-md-2"
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalAgregarTributo.js